export default "__VITE_ASSET__B96t7YEu__"